<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import { authComputed } from '@state/helpers'
import PageHeader from '@components/page-header'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import axios from 'axios'
import moment from 'moment'
import DuplicateLog from '@/src/components/request/DuplicateLog'
import { axiosGetPost } from '@router/axiosGetPost'
import HideColumnsTable from '@components/datatablegn/HideColumnsTable'

export default {
  page: {
    title: 'Accounts LCL',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    DuplicateLog,
    HideColumnsTable,
  },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      title: 'Accounts LCL',
      items: [
        {
          text: 'Barracuda',
          href: '/',
        },
        {
          text: 'Accounts LCL',
          href: '/accounts_lcl',
          active: true,
        },
        {
          text: 'List',
          active: true,
        },
      ],
      time: 0,
      reloadTime: 900,
      timeProgressBar: 0,
      tableData: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'id',
      sortDesc: true,
      fields: [],
      fieldList: [
        { key: 'id', label: 'ID', sortable: true, checkBox: true },
        {
          key: 'company_user',
          label: 'Company User',
          sortable: true,
          checkBox: true,
        },
        {
          key: 'request_id',
          label: 'Request ID',
          sortable: true,
          checkBox: true,
        },
        { key: 'name', label: 'Reference', sortable: true, checkBox: true },
        { key: 'date', label: 'Date', sortable: true, checkBox: true },
        {
          key: 'status',
          label: 'Status Contract',
          sortable: true,
          checkBox: true,
        },
        {
          key: 'is_duplicated',
          label: 'Process Type',
          sortable: true,
          checkBox: true,
        },
        { key: 'actions', label: 'Options', checkBox: false },
      ],
      typeTable: 'AccountListLCL',
      excludeFields: [],
      dateRange: [],
      modalComponent: 'changeStatus',
      modalTitle: 'Status',
      modalError: null,
      modalErrorShow: false,

      requestID: 0,
      showModal: false,
      loadingData: true,
      loadingTable: false,
      duplicateLogs_id: null,
    }
  },
  computed: {
    ...authComputed,
    rows() {
      return this.tableData.length
    },
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fields = this.fieldList
    this.dateRangedef()
    this.getData()
    this.interval = setInterval(() => this.increment(), 1000)
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
  },
  destroyed() {
    clearInterval(this.interval)
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    customFilterTable(row, filter) {
      var valuesRow = Object.values(row)
      //console.log(values)
      let filtersSp = filter.split(' ')
      var flag = false
      const filtersFined = []
      filtersSp.forEach((filterVal) => {
        valuesRow.filter((valRow) => {
          var valRowLC = String(valRow).toLowerCase()
          var filterValLC = String(filterVal).toLowerCase()
          if (valRowLC.includes(filterValLC)) {
            if (!filtersFined.includes(filterVal)) filtersFined.push(filterVal)
          }
        })
      })

      return filtersFined.length === filtersSp.length
    },
    dateRangedef() {
      let d = moment().subtract(1, 'months')
      let d2 = moment()
      this.dateRange = [
        new Date(d.year(), d.month(), d.format('DD')),
        new Date(d2.year(), d2.month(), d2.format('DD')),
      ]
    },
    restore() {
      this.dateRangedef()
      this.getData()
    },
    searchDuplicatedLog(id) {
      axiosGetPost('get', '/requestsLCL/accountSearch/' + id).then(
        (response) => {
          console.log(response)
          let data = response.data
          this.modalTitle = 'Possible Duplicates '
          this.modalComponent = 'DuplicateLog'
          this.showModal = true
          this.duplicateLogs_id = data
          this.loadingData = true
          this.loadingData = false
          return data
        }
      )
    },
    getData() {
      this.loadingTable = true
      this.time = 0
      axiosGetPost('post', '/contractsLcl/account_list', {
        date: this.dateRange,
      }).then((data) => {
        console.log(data)
        this.tableData = data
        this.loadingTable = false
        return data
      })
    },
    increment() {
      this.time = this.time + 1
      if (this.time === this.reloadTime) {
        this.time = 0
        this.getData()
      }
      this.timeProgressBar = (this.time * 100) / this.reloadTime
    },

    /* findIndex(id) {
       var valObj = this.tableData.findIndex(function (elem) {
         if (elem.id === id) return elem
       })
       return valObj
     },
     udapte_row_duplicate_status(id) {
       var valObj = this.tableData.findIndex(function (elem) {
         if (elem.id === id) return elem
       })
       this.showModal = false
       this.tableData[valObj].status = 'Review'
       // console.log(valObj)
     },*/
    saveModal() {
      if (this.modalComponent === 'changeStatus') {
        this.requestStatusMt(
          'change',
          this.requestStatus.id,
          this.requestStatus.index
        )
      }
      this.showModal = false
    },
    downloadFile(id) {
      axiosGetPost('get', '/contractsLcl/downloadF/' + id).then((response) => {
        console.log(response)
        let data = response.data
        if (data.success === true) {
          var link = document.createElement('a')
          link.setAttribute('target', '_blank')
          link.href = data.url
          link.click()
          URL.revokeObjectURL(link.href)
        } else {
          this.$toastr.e(
            'Error Download. Status code: ' +
              data.status +
              ' Error: ' +
              data.error
          )
        }
        return data
      })
    },

    updateModal: function(val) {
      this.showModal = val
    },

    showModalUploadFile(id, detail = null) {
      this.requestID = id
      this.dropzoneOptions.detailTemplate = detail
      this.modalTitle = 'Upload file'
      this.modalComponent = 'uploadFile'
      this.showModal = true
      this.loadingData = false
    },
    updateTableFieldsEmit(fields) {
      this.fields = fields
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-md-2">
              <div class="col-sm-3 col-md-8 text-md-left">
                <h4 class="header-title mt-0 mb-1">Accounts LCL List</h4>
              </div>
              <div class="col-sm-3 col-md-4 text-md-left">
                <p class="text-muted font-13 mb-4">
                  <b-progress
                    :value="timeProgressBar"
                    :max="100"
                    class="mb-3"
                    variant="primary"
                    show-value
                  >
                  </b-progress>
                </p>
              </div>
            </div>
            <div class="row mb-md-2">
              <div class="col-sm-8 col-md-8 text-md-left">
                <date-picker
                  v-model="dateRange"
                  class="col-5"
                  type="date"
                  range
                  placeholder="Select date range"
                  @change="getData"
                >
                </date-picker>
                <b-button
                  class="btn btn-primary col-md-2"
                  variant="primary"
                  @click="getData"
                  >Update</b-button
                >&nbsp;
                <b-button
                  class="btn btn-primary col-md-2"
                  variant="primary"
                  @click.prevent="restore"
                  >Restore</b-button
                >
              </div>
            </div>
            <div class="d-flex mb-md-2">
              <div class="mr-auto">
                <label class="d-inline-flex align-items-center">
                  Show&nbsp;
                  <b-form-select
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select
                  >&nbsp;entries
                </label>
              </div>

              <div>
                <HideColumnsTable
                  :field-list-fth="fieldList"
                  :type-table="typeTable"
                  @updateTableFieldsEmit="updateTableFieldsEmit"
                />
              </div>
              <!-- Search -->

              <div>
                <label class="d-inline-flex align-items-center">
                  Search:
                  <b-form-input
                    v-model="filter"
                    type="search"
                    placeholder="Search..."
                    class="form-control form-control-sm ml-2"
                  ></b-form-input>
                </label>
              </div>

              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0 table-responsive-list-menu">
              <b-table
                striped
                hover
                :items="tableData"
                :fields="fields"
                :busy="loadingTable"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                :filter-function="customFilterTable"
                @filtered="onFiltered"
              >
                <template v-slot:table-busy>
                  <div
                    class="row align-items-center justify-content-center"
                    style="height: 150px"
                  >
                    <div class="col-12 col-md-8 text-center">
                      <b-spinner
                        label="Loading..."
                        variant="primary"
                        class="ml-3"
                      ></b-spinner>
                    </div>
                  </div>
                </template>

                <template v-slot:cell(is_duplicated)="row">
                  <a :href="'#'">
                    <span
                      v-if="row.item.is_duplicated === 0"
                      class="badge"
                      :class="{
                        'badge-soft-success': row.item.is_duplicated === 0,
                      }"
                      >Importation</span
                    >
                  </a>
                  <a :href="'#'">
                    <span
                      v-if="row.item.is_duplicated === 1"
                      class="badge"
                      :class="{
                        'badge-soft-info': row.item.is_duplicated === 1,
                      }"
                      >Duplicated</span
                    >
                  </a>
                </template>

                <template v-slot:cell(actions)="row">
                  <b-dropdown
                    v-if="row.item.error_contract === 0"
                    variant="success"
                    dropleft
                    class="ml-1 btn-sm"
                  >
                    <template slot="button-content">
                      <i class="uil uil-angle-double-left"></i>
                      <i>Options</i>
                    </template>
                    <b-dropdown-item
                      href="#"
                      :to="{
                        name: 'account_import_lcl',
                        params: {
                          id: row.item.request_id,
                          module: 'fcl',
                        },
                      }"
                    >
                      <span style="color: rgb(86 21 21)">
                        <i class="uil uil-file-check-alt"></i>
                        &nbsp; &nbsp; Import Contract
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-item
                      href="#"
                      :to="{
                        name: 'goodandfails_lcl',
                        params: {
                          id: row.item.request_id,
                        },
                      }"
                    >
                      <span style="color: rgb(15, 118, 118)">
                        <i class="uil uil-atm-card"></i>
                        &nbsp; &nbsp; Good & Fail
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-item
                      href="#"
                      :to="{
                        name: 'account_detail_lcl',
                        params: {
                          id: row.item.request_id,
                        },
                      }"
                    >
                      <span style="color: rgb(17 126 203)">
                        <i class="uil uil-file-check-alt"></i>
                        &nbsp; &nbsp; Details
                      </span>
                    </b-dropdown-item>
                    <!--<b-dropdown-item
                      v-if="!row.item.is_duplicated"
                      href="#"
                    >
                      <span
                        style="color: rgb(110 12 199)"
                      >
                        <i class="uil uil-file-check-alt"></i>
                        &nbsp; &nbsp; Reimport
                      </span>
                    </b-dropdown-item>-->
                    <b-dropdown-item
                      v-if="!row.item.is_duplicated"
                      href="#"
                      style="color: ##0a399a"
                      @click="downloadFile(row.item.request_id)"
                    >
                      <span style="color: rgb(1 38 113)"
                        ><i class="uil uil-cloud-download"></i>&nbsp; &nbsp;
                        Download File</span
                      >
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-else
                      href="#"
                      @click="searchDuplicatedLog(row.item.request_id)"
                      style="color: ##0a399a"
                    >
                      <span style="color: rgb(1 38 113)"
                        ><i class="uil uil-search"></i>&nbsp; &nbsp; Duplicated
                        Log</span
                      >
                    </b-dropdown-item>
                  </b-dropdown>

                  <b-dropdown
                    v-else
                    variant="success"
                    dropleft
                    class="ml-1 btn-sm"
                  >
                    <template slot="button-content">
                      <i class="uil uil-angle-double-left"></i>
                      <i style="color: red">Error Review</i>
                    </template>
                  </b-dropdown>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-lefts"
                >
                  <span>
                    <!--<i>Total Rows: {{ rows }}</i>-->
                  </span>
                </div>
              </div>
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal de Cambio de status -->
      <!-- <b-button variant="success" @click="test">methods</b-button> -->
      <b-modal
        id="modal-lg"
        ref="requestFcl"
        v-model="showModal"
        size="lg"
        :title="modalTitle"
        title-class="font-18"
      >
        <div
          v-if="loadingData"
          class="row align-items-center justify-content-center"
          style="height: 300px"
        >
          <div class="col-12 col-md-8 text-center">
            <b-spinner
              label="Loading..."
              variant="primary"
              class="ml-3"
            ></b-spinner>
          </div>
        </div>

        <div v-else-if="modalErrorShow === true">
          <div
            class="row align-items-center justify-content-center"
            style="height: 300px"
          >
            <div class="col-12 col-md-8 text-center">
              <feather type="frown" class="icon-xxl icon-dual-info"></feather>
              <h6 class="text-muted">{{ modalError }}</h6>
            </div>
          </div>
        </div>

        <DuplicateLog
          v-else-if="modalComponent === 'DuplicateLog'"
          :request-id="duplicateLogs_id"
          type="FCL"
        />
        <template v-slot:modal-footer>
          <b-button variant="light" @click="$refs.requestFcl.hide"
            >Close</b-button
          >
          <b-button
            v-if="
              loadingData === false &&
                modalErrorShow === false &&
                modalComponent !== 'DuplicateLog'
            "
            variant="primary"
            @click="saveModal"
          >
            OK
          </b-button>
        </template>
      </b-modal>
    </div>
  </Layout>
</template>

<style>
/*.dropdown-menu {
    position:static !important
}*/

/*body {
  --table-width: 100%; 
}
tbody {
  display:block;
  max-height:500px;
  overflow-y:auto;
}
thead, tbody tr {
  display:table;
  width: var(--table-width);
  table-layout:fixed;
}*/

.table-responsive-list-menu {
  overflow-x: visible !important;
  overflow-y: visible !important;
}

.badge-soft-warning {
  color: #c39411 !important;
  background-color: rgba(255, 190, 11, 0.2);
}

.badge-soft-success {
  color: #299a70 !important;
  background-color: rgba(67, 211, 158, 0.2);
}

.badge-soft-info {
  color: #259cb5 !important;
  background-color: rgba(37, 194, 227, 0.2);
}

.badge-soft-pdp {
  color: #a243d3 !important;
  background-color: rgb(162 67 211 / 20%);
}

.badge-tier-1 {
  color: #ffffff !important;
  background-color: #1f56d6;
}

.badge-tier-2 {
  color: #ffffff !important;
  background-color: #1f93d6;
}

.badge-tier-3 {
  color: #ffffff !important;
  background-color: #1dbfd7;
}

.btn-success:hover {
  color: #010b55;
  background-color: #e9e9e9;
  border-color: #001add;
}

.btn-success {
  color: #0014a2;
  background-color: #ffffff;
  border-color: #031b4e;
}

.show .btn-success.dropdown-toggle {
  color: #010b55;
  background-color: #e9e9e9;
  border-color: #001add;
}

.text {
  font-family: helvetica;
  font-weight: bold;
  color: #71d90b;
}

.parpadea {
  animation-name: parpadeo;
  animation-duration: 2s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;

  -webkit-animation-name: parpadeo;
  -webkit-animation-duration: 2s;
  -webkit-animation-timing-function: linear;
  -webkit-animation-iteration-count: infinite;
}

@-moz-keyframes parpadeo {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-webkit-keyframes parpadeo {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes parpadeo {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
